module.exports = __webpack_public_path__ + "img/icon-image-asset.bcd31030.svg";